import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    toolTip: {
      fontSize: '1.2em',
      lineHeight: '1.4em'
    }
  });
});
